import React from 'react';

import {getTranslationData, useGallerySpec} from '../../util/gallery';
import {ReportPageLanguageTags} from './ReportPageLanguageTags';
import {ReportPageRSSLinks} from './ReportPageRSSLinks';

type ReportPageMetaTagsProps = {
  viewId: string;
};

export const ReportPageMetaTags = ({viewId}: ReportPageMetaTagsProps) => {
  const {
    gallerySpec: {reportIDsWithTagV2IDs},
  } = useGallerySpec();

  // Use the V2 list: it's the source of truth the report admin bar writes to
  // (including the `isTranslationOf` link) and what the SSR host reads when
  // emitting hreflang tags. The legacy V1 list is no longer updated on save.
  const translationData = getTranslationData(reportIDsWithTagV2IDs, viewId);
  return (
    <>
      <ReportPageRSSLinks />
      {translationData != null && (
        <ReportPageLanguageTags translationData={translationData} />
      )}
    </>
  );
};
